import { combineReducers } from 'redux';

import data from './data';
import list from './list';

export default combineReducers({
    data,
    list
});
